module.exports = __webpack_public_path__ + "static/img/icon_giftcard_cancelVerification.ee02cbd1.png";